import { computed, toValue, type MaybeRefOrGetter } from "vue";
import type { CanvassTargetWithProgress } from "./types";

export function useReachedCanvassTargets(
  canvassTargetsWithProgress: MaybeRefOrGetter<
    Array<CanvassTargetWithProgress>
  >,
) {
  const reachedCanvassTargetsCount = computed(
    () =>
      toValue(canvassTargetsWithProgress).filter(
        ({ satisfiedTargets, target }) => satisfiedTargets >= target,
      ).length,
  );

  return { reachedCanvassTargetsCount };
}
